export default __webpack_public_path__ + "static/media/detail_big_12_7.3589ebc9.jpg";